/**
 * CSP-safe substitution of dollar-brace placeholders (no eval / new Function).
 * Unknown keys are left unchanged.
 * @param {string|null|undefined} text - Text that may contain placeholders.
 * @param {Record<string, unknown>} [vars] - Values keyed by placeholder name.
 * @returns {string} Text with matching placeholders filled in.
 */
export const fillPlaceholders = (text, vars = {}) => (
  String(text ?? '').replace(/\$\{(\w+)\}/g, (_, key) => (
    Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : `$\{${key}}`
  ))
);
